import { twoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import { headerStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader";
import { userInformationStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsUserInformation";
import { addressBookStyles } from "@insite/content-library/Widgets/Addresses/AddressBook";
import { createAddressButtonStyles } from "@insite/content-library/Widgets/Addresses/CreateAddressButton";
import { currentBillingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentBillingAddress";
import { currentShippingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress";
import { changeCustomerSelectCustomerContainerStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { createListButtonStyles } from "@insite/content-library/Widgets/MyLists/MyListsCreateListButton";
import { productListStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductList";
import { productListLineStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { savedOrderDetailsProductListStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsProductList";
import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import { staticListProductListStyles } from "@insite/content-library/Widgets/StaticList/StaticListProductList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Modal from "@insite/mobius/Modal";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { customerAddressFormStyles } from "@theStellarBlueprint/Overrides/Components/CustomerAddressForm";
import { css } from "styled-components";

createListButtonStyles.createListButton = {
    variant: "tertiary",
};

Modal.defaultProps!.closeButtonProps = {
    css: css`
        transition: none !important;
        border: none !important;
        &:hover {
            background: none !important;
            border: none !important;
            outline: none !important;
        }
    `,
};

wishListCardStyles.actionAddToCartButton = {
    variant: "primary",
    css: css`
        width: 100%;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        padding: 0px 2px;
                    `,
                    null,
                ],
                "minMax",
            )}
    `,
};

twoButtonModalStyles.submitButton = {
    variant: "primary",
};

customerAddressFormStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

// Shipping Style
currentShippingAddressStyles.useBillingAddress = {
    button: {
        variant: "primary",
        css: css`
            & span {
                text-transform: none;
                font-weight: 600;
            }
        `,
    },
};

currentShippingAddressStyles.editLink = {
    css: css`
        line-height: 34px;
        flex-basis: 100%;
        max-width: 100%;
    `,
};

// Address Book Section style
addressBookStyles.addressCard!.actionUseAsShippingAddressButton = {
    variant: "tertiary",
};

addressBookStyles.titleText = {
    css: css`
        font-size: 20px;
        font-weight: 700;
        margin-top: 4px;
        margin-bottom: 1rem;
        flex-basis: 100%;
        max-width: 100%;
    `,
};

// Create Address Button Style
createAddressButtonStyles.createNewAddressButton = {
    css: css`
        width: 213px;
        & span {
            text-transform: none;
            font-weight: 600;
        }
    `,
};

createAddressButtonStyles.createNewAddressButtonGridItem = {
    css: css`
        flex-direction: row;
        padding: 15px;
        padding-right: 0;
        align-items: flex-start;
        overflow-wrap: break-word;
        word-wrap: break-word;
        -ms-word-break: break-all;
        word-break: break-all;
        word-break: break-word;
        -webkit-flex-basis: 100%;
        -ms-flex-preferred-size: 100%;
        flex-basis: 100%;
        max-width: 100%;
        -webkit-box-pack: end;
        -webkit-justify-content: flex-end;
        -ms-flex-pack: end;
        justify-content: flex-end;
    `,
};

// Biling
currentBillingAddressStyles.headingText = {
    css: css`
        font-size: 20px;
        line-height: 25px;
        font-weight: 700;
        margin-bottom: 1rem;
        display: block;
        flex-basis: 83.333333%;
        max-width: 83.333333%;
    `,
};

currentBillingAddressStyles.editLink = {
    css: css`
        line-height: 26px;
        flex-basis: 100%;
        max-width: 100%;
    `,
};

savedOrderListFilterStyles.clearFiltersButton = {
    variant: "tertiary",
};

userInformationStyles.userInformationTitle = {
    css: css`
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 1rem;
        display: block;
        & + div[class^="GridWrapper"] {
            div[class^="GridOffset"] {
                flex-basis: 100%;
                max-width: 100%;
                margin-bottom: 0;
            }
            & + h2 {
                font-size: 16px;
                font-weight: 700;
                margin-bottom: 1rem;
                display: block;
            }
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.container = {
    css: css`
        div[class^="GridOffset"] {
            margin: -15px;
        }

        input:focus {
            border: 1px solid #ccc !important;
        }

        [data-test-selector="changeCustomerBillToSelector-listbox"],
        ul[data-test-selector="changeCustomerShipToSelector-listbox"] {
            border: 0;
            position: relative !important;
            top: 0px;
            div[aria-selected="true"] {
                color: ${getColor("primary.main")};
                background: transparent;
                font-weight: 600;
                border: 1px solid ${getColor("primary.main")};
            }
        }
    `,
};

wishListCardStyles.gridContainer = {
    css: css`
        div[class^="GridItemStyle"] {
            &:last-of-type {
                padding-left: 0;
            }
            & div[class^="GridOffset"] {
                margin: 0;
                width: 100%;
                div[class^="GridItemStyle"] {
                    padding: 0;
                    div[class^="GridOffset"] {
                        margin: 0;
                        width: 100%;
                        div[class^="GridItemStyle"] {
                            padding: 15px 0 15px 5px;
                            a[class^="StyledButton"] {
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(theme, [
                                        null,
                                        null,
                                        css`
                                            width: 28%;
                                        `,
                                        null,
                                        null,
                                    ])}
                            }
                            div[class^="TooltipWrapper"] {
                                div: last-child {
                                    left: 50px;
                                    div: last-child {
                                        &::after {
                                            content: "";
                                            position: absolute;
                                            top: 100%;
                                            left: 30%;
                                            margin-left: -6px;
                                            border-width: 6px;
                                            border-style: solid;
                                            border-color: ${getColor("common.backgroundContrast")} transparent
                                                transparent transparent;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `,
};

wishListSharingStatusStyles.statusText = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-left: 32px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ],
                "minMax",
            )}
    `,
};

productListLineStyles.quantityGridItem = {
    css: css`
        flex-basis: 35%;
        max-width: 35%;
        padding: 0 20px;
    `,
};

savedOrderDetailsProductListStyles.wrapper = {
    css: css`
        .priceLabel {
            display: inline-block;
            margin-right: 5px;
        }
    `,
};

productListStyles.container = {
    css: css`
        .priceLabel {
            display: inline-block;
            margin-right: 5px;
        }
    `,
};

staticListProductListStyles.mainWrapper = {
    css: css`
        .priceLabel {
            display: inline-block;
            margin-right: 5px;
        }
    `,
};

savedOrderListFilterStyles.container = {
    css: css`
        [class^="GridItemStyle"] {
            overflow-wrap: break-word;
            word-break: break-word;
            .react-datetime-picker__button {
                border: 0px;
                background: transparent;
                padding: 0px;
                position: absolute;
                right: 9px;
                top: 50%;
                transform: translateY(-50%);
                span {
                    background: transparent;
                }
            }

            .react-datetime-picker__inputGroup__leadingZero {
                padding: 0.2em 0 0.5em 0.3em;
                ~ input {
                    padding: 0.2em 0.2em 0.3em;
                }
            }

            .react-datetime-picker {
                padding: 7px !important;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            label {
                                font-size: 15px !important;
                            }
                        `,
                        null,
                        css`
                            padding: 10px 5px;
                            label {
                                font-size: 12px;
                            }

                            @supports (-webkit-touch-callout: none) {
                                .react-datetime-picker {
                                    padding: 5px 2px 5px 0;
                                }
                            }
                            .react-datetime-picker__button {
                                right: 2px;
                                span {
                                    width: 34px;
                                }
                            }
                        `,
                        null,
                    ],
                    "max",
                )}

            [class^="GridOffset"] {
                display: flex;
                flex-wrap: wrap;
                width: 100%;
                margin: 0;
            }

            &:nth-child(2) {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                flex-basis: 100% !important;
                                max-width: 100% !important;
                                [class^="GridItemStyle"] {
                                    flex-basis: 50% !important;
                                    max-width: 50% !important;
                                }
                            `,
                            css`
                                flex-basis: 100% !important;
                                max-width: 100% !important;
                                [class^="GridItemStyle"] {
                                    flex-basis: 50% !important;
                                    max-width: 50% !important;
                                }
                            `,
                            css`
                                flex-basis: 50%;
                                max-width: 50%;
                            `,
                            css`
                                flex-basis: 50%;
                                max-width: 50%;
                            `,
                            null,
                        ],
                        "max",
                    )}
            }

            &:nth-child(3) {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                flex-basis: 100% !important;
                                max-width: 100% !important;
                                [class^="GridItemStyle"] {
                                    flex-basis: 50% !important;
                                    max-width: 50% !important;
                                }
                            `,
                            css`
                                flex-basis: 100% !important;
                                max-width: 100% !important;
                                [class^="GridItemStyle"] {
                                    flex-basis: 50% !important;
                                    max-width: 50% !important;
                                }
                            `,
                            css`
                                flex-basis: 50%;
                                max-width: 50%;
                            `,
                            css`
                                flex-basis: 50%;
                                max-width: 50%;
                            `,
                            null,
                        ],
                        "max",
                    )}
            }

            &:last-child {
                justify-content: flex-end;
            }
        }
    `,
};

savedOrderListFilterStyles.datesContainer = {
    gap: 10,
    css: css`
        div[data-test-selector="savedOrderList_fromDateFilter"] {
            > div {
                width: 100%;
            }
        }
        div[data-test-selector="savedOrderList_toDateFilter"] {
            > div {
                width: 100%;
            }
        }
    `,
};
